import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import formDefault from "../../docs/formDefault.json";
import { createElement } from "commonAssets/lib/createElement";
import { modal } from "commonAssets/lib/modal";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import { validateField } from "commonAssets/lib/validateField";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { i18n, loading, outputDiv } from "commonAssets/js/constants";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";

export function getPurl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("uuid");
}

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                if (form.form_options.notice_confirmation.display === true) {
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");
                    const guardForm = document.getElementById("guard");
                    const submitGuard =
                        document.getElementById("submit-guard");

                    [zero_zero_id, confirmation_code].forEach((input) => {
                        input.addEventListener("change", validateField);
                    });

                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            guardForm?.remove();
                            container.appendChild(this.claim_form(form, datetime));
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);
                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );
                        });
                    }

                    submitGuard?.addEventListener("click", () => {
                        guardForm?.classList.add("was-validated");
                    });

                    const parseMaybeJson = (value) => {
                        if (!value) {
                            return null;
                        }
                        if (typeof value === "string") {
                            try {
                                return JSON.parse(value);
                            } catch {
                                return null;
                            }
                        }
                        if (typeof value === "object") {
                            return value;
                        }
                        return null;
                    };

                    const getDeficiencyStatus = (data) => {
                        const cmDataRaw = data.claim_id
                            ? data.class_member?.cm_data
                            : data.cm_data;
                        const cmData = parseMaybeJson(cmDataRaw);

                        let isDeficient = false;
                        let canEdit = false;
                        let deficiencyReason = null;

                        const statuses = cmData?.ClassMemberStatus;
                        if (Array.isArray(statuses)) {
                            for (const status of statuses) {
                                if (
                                    status?.Label === "Deficient" &&
                                    status?.Active === true
                                ) {
                                    isDeficient = true;
                                    if (status?.CanEdit === true) {
                                        canEdit = true;
                                    }
                                    if (
                                        typeof status?.Reason === "string" &&
                                        status.Reason.trim() !== ""
                                    ) {
                                        deficiencyReason = status.Reason.trim();
                                    }
                                    break;
                                }
                            }
                        }

                        const legacyCanEdit = data.claim_id
                            ? data.class_member?.can_edit
                            : data.can_edit;
                        const legacyIsDeficient = data.claim_id
                            ? data.class_member?.is_deficient
                            : data.is_deficient;

                        return {
                            canEdit: canEdit || Boolean(legacyCanEdit),
                            isDeficient: isDeficient || Boolean(legacyIsDeficient),
                            deficiencyReason,
                        };
                    };

                    guardForm?.classList.add("d-none");

                    guardForm?.addEventListener("submit", (e) => {
                        e.preventDefault();

                        let valid = true;
                        const member = {
                            domain: this.claim.data.domain,
                            zero_zero_id: zero_zero_id.value.toUpperCase(),
                            confirmation_code: confirmation_code.value,
                        };

                        clearMessage();

                        [zero_zero_id, confirmation_code].forEach((input) => {
                            valid = validateField(input) && valid;
                        });
                        if (!valid) return;

                        loadingGif(loading, "show");

                        this.claim.api
                            .classMemberPost({}, member)
                            .then((memberResult) => {
                                if (memberResult.data.error) {
                                    toggleFieldError(zero_zero_id, true, "");
                                    toggleFieldError(confirmation_code, true, "");
                                    this.errorHandler.log_exception(
                                        new Error("Error loading class member", {
                                            cause: memberResult,
                                        })
                                    );
                                    this.errorHandler.display_modal(memberResult);
                                    return;
                                }

                                const { canEdit, isDeficient, deficiencyReason } =
                                    getDeficiencyStatus(memberResult.data);

                                if (!isDeficient || !canEdit) {
                                    modal(
                                        i18n.getTranslation("error"),
                                        `<p>This portal is not open to new claims.</p>`
                                    );
                                    loadingGif(loading, "hide", 250);
                                    return;
                                }

                                if (deficiencyReason) {
                                    this.claim.data.deficiency_reason =
                                        deficiencyReason;
                                }

                                this.claim.data.zero_zero_id =
                                    member.zero_zero_id;
                                this.claim.data.confirmation_code =
                                    member.confirmation_code;

                                const environment =
                                    this.claim.data.domain.split(".")[0];

                                if (memberResult.data.claim_id) {
                                    this.claim.data.claim_id =
                                        memberResult.data.claim_id;
                                    this.claim.class_member = memberResult.data;
                                    if (environment !== "local") {
                                        this.send_otp(
                                            form,
                                            container,
                                            memberResult.data,
                                            claim_deadline
                                        );
                                        return;
                                    }
                                }

                                this.populate_claim_form(
                                    form,
                                    container,
                                    memberResult.data,
                                    claim_deadline
                                );
                            })
                            .catch((error) => {
                                this.errorHandler.log_exception(
                                    new Error("Error loading class member", {
                                        cause: error,
                                    })
                                );
                                this.errorHandler.display_modal(error);
                            });
                    });

                    const purl = getPurl();
                    if (purl) {
                        const member = {
                            domain: this.claim.data.domain,
                            purl,
                        };

                        this.claim.api
                            .classMemberPost({}, member)
                            .then((memberResult) => {
                                if (memberResult.data.error) {
                                    guardForm?.classList.remove("d-none");
                                    loadingGif(loading, "hide", 250);
                                    return;
                                }

                                zero_zero_id.value =
                                    memberResult.data.zero_zero_id;
                                confirmation_code.value =
                                    memberResult.data.confirmation_code;
                                submitGuard?.click();
                            })
                            .catch(() => {
                                guardForm?.classList.remove("d-none");
                                loadingGif(loading, "hide", 250);
                            });
                    } else {
                        guardForm?.classList.remove("d-none");
                        loadingGif(loading, "hide", 250);
                    }
                } else {
                    this.edit_claim(form);

                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);

                    this.init_claim_fields(this.claim, form, claim_deadline);
                    loadingGif(loading, "hide", 250);
                }
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input, #claim-fields textarea, #claim-fields select, #co_first_name, #co_last_name, #co_owner_signature, #co_owner_date";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "#transactions input, #transactions textarea, #transactions select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
